import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=7f205f88&scoped=true"
import script from "../../services/ticketing/Teams.js?vue&type=script&lang=js&external"
export * from "../../services/ticketing/Teams.js?vue&type=script&lang=js&external"
import style0 from "./Teams.vue?vue&type=style&index=0&id=7f205f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f205f88",
  null
  
)

export default component.exports